import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=8b924a7a"
var script = {}
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=8b924a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports